




import Vue from 'vue';
import { Model, Prop } from 'vue-property-decorator';
import Component from 'vue-class-component';

@Component({
	componentId: 'C025',
	components: {},
	inheritAttrs: false
})
export default class HiddenInput extends Vue {
	@Prop(String)
	protected readonly id!: string;

	@Prop({ type: String, default: '' })
	protected readonly name!: string;

	@Model('input', { type: String, default: '' })
	protected value!: string;

	protected get inputId(): string {
		return `${this.id}-input`;
	}

	protected onInput(event: Event): void {
		this.$emit('input', (event.target as HTMLInputElement).value);
	}
}
